import { createSlice } from '@reduxjs/toolkit';

// Function to load favorites from sessionStorage
const loadFavoritesFromLocalStorage = () => {
  try {
    const favorites = JSON.parse(localStorage.getItem('favorites'));
    return Array.isArray(favorites) ? favorites : [];
  } catch (error) {
    return [];
  }
};

// Initial state
const initialState = {
  favorites: loadFavoritesFromLocalStorage(),
};

// Create the favorites slice
const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    setFavorites(state, action) {
      state.favorites = action.payload;
    localStorage.setItem('favorites', JSON.stringify(action.payload));
    },
    addFavorite(state, action) {
      if (!state.favorites.some((fav) => fav.id === action.payload.id)) {
        state.favorites.push(action.payload);
        localStorage.setItem('favorites', JSON.stringify(state.favorites));
      }
    },
    removeFavorite(state, action) {
      state.favorites = state.favorites.filter(
        (fav) => fav.id !== action.payload.id
      );
      localStorage.setItem('favorites', JSON.stringify(state.favorites));
    },
  },
});

export const { setFavorites, addFavorite, removeFavorite } = favoritesSlice.actions;
export default favoritesSlice.reducer;
